import { useState } from "react"
import { EnkNavButtons, EnkMenuButton, EnkMoreMenuButton, EnkPrimaryButton } from "../components/common/buttons"
import EnkCalendarWeekView from "../components/calendar/week-view"
import EnkMonthView from "../components/calendar/month-view"
import EnkDayView from "../components/calendar/day-view"
import EnkYearView from "../components/calendar/year-view"
import { addDays, addMonths, addWeeks, addYears, format, getISOWeek } from "date-fns"
import EnkPageContainer from "../components/page-container"

export default function EnkCalendar() {
  const [view, setView] = useState<string>("Week")
  const [selectedDate, setSelectedDate] = useState<Date>(new Date())

  const currentLocale = "nl-nl"

  const renderView = () => {
    switch (view) {
      case "Dag":
        return <EnkDayView selectedDate={selectedDate} setSelectedDate={setSelectedDate} currentLocale={currentLocale} />
      case "Week":
        return <EnkCalendarWeekView selectedDate={selectedDate} setSelectedDate={setSelectedDate} currentLocale={currentLocale} />
      case "Maand":
        return <EnkMonthView selectedDate={selectedDate} setSelectedDate={setSelectedDate} currentLocale={currentLocale} />
      case "Jaar":
        return <EnkYearView selectedDate={selectedDate} setSelectedDate={setSelectedDate} currentLocale={currentLocale} />
      default:
        return <EnkCalendarWeekView selectedDate={selectedDate} setSelectedDate={setSelectedDate} currentLocale={currentLocale} />
    }
  }

  const renderTitle = () => {
    switch (view) {
      case "Dag":
        return (
          <time dateTime={format(selectedDate, "yyyy-MM-dd")}>
            {selectedDate.toLocaleDateString(currentLocale, { weekday: "short", year: "numeric", month: "long", day: "numeric" })}
          </time>
        )
      case "Week":
        return (
          <time dateTime={format(selectedDate, "yyyy-MM-dd")}>
            week {getISOWeek(selectedDate)} - {selectedDate.getFullYear()}
          </time>
        )
      case "Maand":
        return (
          <time dateTime={format(selectedDate, "yyyy-MM")}>{selectedDate.toLocaleDateString(currentLocale, { year: "numeric", month: "long" })}</time>
        )
      case "Jaar":
        return <time dateTime={format(selectedDate, "yyyy")}>{selectedDate.getFullYear()}</time>
      default:
        return <h1 className="text-base font-semibold leading-6 text-gray-900">??</h1>
    }
  }

  const handleDateNav = (step: number) => {
    switch (view) {
      case "Dag":
        setSelectedDate(addDays(selectedDate, step))
        break
      case "Week":
        setSelectedDate(addWeeks(selectedDate, step))
        break
      case "Maand":
        setSelectedDate(addMonths(selectedDate, step))
        break
      case "Jaar":
        setSelectedDate(addYears(selectedDate, step))
        break
    }
  }

  const handleGotoToday = () => {
    setSelectedDate(new Date())
  }

  const handleNewEvent = () => {
    console.log("New event")
  }

  const handleMoreOptionClick = (item: string) => {
    switch (item) {
      case "Maak afspraak":
        handleNewEvent()
        break
      case "Naar vandaag":
        handleGotoToday()
        break
      case "Dag weergave":
        setView("Dag")
        break
      case "Week weergave":
        setView("Week")
        break
      case "Maand weergave":
        setView("Maand")
        break
      case "Jaar weergave":
        setView("Jaar")
    }
  }

  return (
    <EnkPageContainer>
      <div className="flex h-full flex-col">
        <header className="flex flex-none items-center justify-between border-b border-gray-200 px-6 py-4">
          <h1 className="text-base font-semibold leading-6 text-gray-900">{renderTitle()}</h1>
          <div className="flex items-center">
            <EnkNavButtons
              onPrev={() => handleDateNav(-1)}
              onNext={() => handleDateNav(1)}
              onMiddle={handleGotoToday}
              kind="periode"
              middleText="Vandaag"
            />

            <div className="hidden md:ml-4 md:flex md:items-center">
              <EnkMenuButton
                text={view}
                items={["Dag", "Week", "Maand", "Jaar"]}
                onItemSelected={(item) => {
                  setView(item)
                }}
              />
              <div className="ml-6 h-6 w-px bg-gray-300" />
              <EnkPrimaryButton text="Add event" />
            </div>

            <EnkMoreMenuButton
              items={[["Maak afspraak"], ["Naar vandaag"], ["Dag weergave", "Week weergave", "Maand weergave", "Jaar weergave"]]}
              onItemSelected={(item) => {
                handleMoreOptionClick(item)
              }}
            />
          </div>
        </header>

        {renderView()}
      </div>
    </EnkPageContainer>
  )
}
